import { devLogger } from 'src/common/utilities';

const loadLocalization = async (type: string, locale: string) => {
  // remember sometimes they put a "title" field in the "imageLayoutContent" field in the JSON file: always change it to "description"
  const localeCode = locale.toLowerCase() ?? 'en-gb';
  try {
    const res = await import(`../locales/${type}_${localeCode}.ts`);
    if (!res) return;
    return res?.default;
  } catch (err: any) {
    devLogger.warn(err.message, '-> Falling back to the default dictionary');
  }
};

export default loadLocalization;
